import React from "react";
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import {
    Grid,
    Card,
    CardContent,
    CircularProgress,
    Button,
    Stepper,
    Step,
    StepLabel,
    Typography,
    FormControl,
    InputLabel,
    InputAdornment,
    IconButton,
    OutlinedInput,
    CardHeader,
    Table,
    TableCell,
    TableRow,
    TableHead,
    TableBody
} from "@material-ui/core";
import FileIcon from "@material-ui/icons/InsertDriveFile";
import { getSpecificClients } from "views/clients/api/apiClients";
import SelectClient from "common/components/custom/SelectClient";
import { handleUploadFileChartOfAccount } from "../api/apiImport";

class ImportChartOfAccount extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            activeStep: 0,
            fileName: null,
            selectedClient: null,
            specificsClients: [],
            fileData: null,
            stepFailed: false,
            responseData: {},
            isLoadingImport: false
        };
    }

    async componentDidMount() {
        this.getSpecificClients()
    }

    getSpecificClients = () => {
        getSpecificClients().then((response) => {
            let selectedClient = response.data.data.length > 0 ? response.data.data[0] : null
            this.setState({ specificsClients: response.data.data, selectedClient: selectedClient });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getStepContent = (stepIndex) => {
        switch (stepIndex) {
            case 0:
                return this.props.t("select_account_file");
            default:
                return this.props.t("");
        }
    }

    handleNext = () => {
        this.setState({ activeStep: this.state.activeStep + 1 })
    };

    handleBack = () => {
        this.setState({ activeStep: this.state.activeStep - 1 })
    };

    handleReset = () => {
        this.setState({ activeStep: 0 })
    };

    isStepFailed = () => {
        let { activeStep, stepFailed } = this.state
        return activeStep === 3 && stepFailed ? activeStep === 3 : activeStep === -1;
    };

    handleChange = (client) => {
        if (client !== null) {
            this.setState({ selectedClient: client })
        } else {
            this.setState({ selectedClient: null })
        }
    }

    handleChangeFile = (e) => {
        let file = e.target.files[0];
        if (!file) {
            return;
        }
        const data = new FormData()
        data.append('file', file)
        this.setState({ fileName: file.name, fileData: data, activeStep: 1 })
    }

    importFile = () => {
        this.setState({ isLoadingImport: true })
        setTimeout(() => { this.setState({ activeStep: 2 }) }, 1500)
        setTimeout(() => { this.handleUploadFile() }, 1500)
    }

    handleUploadFile = () => {
        handleUploadFileChartOfAccount({ params: { clientId: this.state.selectedClient.id } }, this.state.fileData).then(response => {
            this.setState({ activeStep: 3, responseData: response.data.data, isLoadingImport: false })
            this.props.enqueueSnackbar(this.props.t("success_import"), { variant: 'success' });
        }).catch(error => {
            if (error.response.status === 400) {
                this.setState({ activeStep: 3, stepFailed: true, responseData: error.response.data.data, isLoadingImport: false })
            }
            this.props.enqueueSnackbar(this.props.t("import_failed"), { variant: 'error' });
        })
    }

    render() {

        let { isLoading, activeStep, fileName, specificsClients, selectedClient, responseData, isLoadingImport } = this.state;

        let steps = [this.props.t("select_file"), this.props.t("processing_data"), this.props.t("processing_finished")]

        if (isLoading) {
            return (
                <div className="loading-position">
                    <CircularProgress className="spinner" color="primary" />
                </div>
            )
        }

        return <Grid container direction="row" spacing={2}>
            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                <Card>
                    <CardContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={2} sm={2} md={2} lg={2} xl={2}>
                                <Grid container direction="row" spacing={2}>
                                    <SelectClient
                                        specificsClients={specificsClients}
                                        selectedClient={selectedClient}
                                        handleChange={this.handleChange}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <br />
                        {selectedClient !== null && <><Stepper activeStep={activeStep} alternativeLabel>
                            {steps.map((label, index) => {
                                const stepProps = {};
                                const labelProps = {};
                                if (this.isStepFailed(index)) {
                                    if (label === this.props.t("processing_finished") && this.state.stepFailed) {
                                        labelProps.error = true;
                                    }
                                }
                                return (
                                    <Step key={label} {...stepProps}>
                                        <StepLabel {...labelProps}>{label}</StepLabel>
                                    </Step>
                                );
                            })}
                        </Stepper>
                            <Grid container direction="row" spacing={2}>
                                <Grid item container direction="column" xs={6} sm={6} md={5} lg={4} xl={3}>
                                    <Typography>{this.getStepContent(activeStep)}</Typography>
                                    <input
                                        disabled={!selectedClient}
                                        style={{ display: 'none' }}
                                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                        id="powerSystemModelFile"
                                        name="powerSystemModel"
                                        type="file"
                                        onChange={(e) => { this.handleChangeFile(e); this.setState(() => e.target.value = null) }}
                                    />
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel margin="dense" >{fileName ? this.props.t("selected_xlsx_file") : this.props.t("select_xlsx_file")}</InputLabel>
                                        <OutlinedInput
                                            label={fileName ? this.props.t("selected_xlsx_file") : this.props.t("select_xlsx_file")}
                                            name="fileName"
                                            disabled={true}
                                            value={fileName || ''}
                                            margin="dense"
                                            size="small"
                                            variant="outlined"
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <label htmlFor="powerSystemModelFile">
                                                        <IconButton
                                                            component="span"
                                                            edge="end"
                                                        >
                                                            <FileIcon />
                                                        </IconButton>
                                                    </label>
                                                </InputAdornment>
                                            }
                                            labelWidth={70}
                                        />
                                    </FormControl>
                                    <br />
                                    {fileName && <Grid item container direction="column" xs={6} sm={6} md={5} lg={4} xl={3}>
                                        <Button style={{ width: '131px', height: '40px' }} variant="contained" color="primary" disabled={isLoadingImport} onClick={() => this.importFile()}>
                                            {isLoadingImport ? <CircularProgress
                                                size={20}
                                                color="secondary"
                                            /> : this.props.t("submit")}
                                        </Button>
                                    </Grid>}
                                </Grid>
                            </Grid></>}

                    </CardContent>
                </Card>
                <br />
                <Grid container direction="row" spacing={2}>
                    <Grid item container direction="column" xs={6} sm={6} md={7} lg={7} xl={5}>
                        <Card>
                            <CardHeader
                                title={this.props.t("excel_example")}
                            />
                            <CardContent>
                                    <p>{this.props.t("excel_example_row1")}</p>
                                    <p>{this.props.t("excel_example_row2")}</p>
                                    <p>{this.props.t("excel_example_row3")}</p>
                                    <p><b>[{this.props.t("account_number")}] [{this.props.t("description")}] [{this.props.t("allowed_postings")}] [{this.props.t("related_account")}]</b></p>
                                    <p>{this.props.t("excel_example_row4")}</p>
                                    <Table aria-label="simple table" size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className="custom-excel-cell" component="th" scope="row" width="10%" ></TableCell>
                                                <TableCell className="custom-excel-cell" component="th" scope="row" width="20%" align="center">A</TableCell>
                                                <TableCell className="custom-excel-cell" component="th" scope="row" width="40%" align="center">B</TableCell>
                                                <TableCell className="custom-excel-cell" component="th" scope="row" width="20%" align="center">C</TableCell>
                                                <TableCell className="custom-excel-cell" component="th" scope="row" width="10%" align="center">D</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell className="custom-excel-cell" align="center">1</TableCell>
                                                <TableCell className="table-custom-border">0</TableCell>
                                                <TableCell className="table-custom-border">This account is for vehicles</TableCell>
                                                <TableCell className="table-custom-border">N</TableCell>
                                                <TableCell className="table-custom-border">2</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell className="custom-excel-cell" align="center">2</TableCell>
                                                <TableCell className="table-custom-border">01</TableCell>
                                                <TableCell className="table-custom-border">This account is for furniture</TableCell>
                                                <TableCell className="table-custom-border">O</TableCell>
                                                <TableCell className="table-custom-border">1</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                            </CardContent>
                        </Card>
                    </Grid>
                    {Object.keys(responseData).length > 0 && <Grid item container direction="column" xs={6} sm={6} md={5} lg={4} xl={3}>
                        <Card>
                            <CardContent style={{ backgroundColor: '#c1f7c1' }}>
                                <p><span><b>{this.props.t("file_name")}: </b></span><span>{responseData && responseData.fileName}</span></p>
                                <p><span><b>{this.props.t("file_extension")}: </b></span> <span>{responseData && responseData.fileExtension}</span></p>
                                <p><span><b>{this.props.t("worksheet_name")}: </b></span><span>{responseData && responseData.worksheetName}</span></p>
                                <p><span><b>{this.props.t("number_of_rows")}: </b></span><span>{responseData && responseData.numberOfRows}</span></p>
                                <p><span><b>{this.props.t("number_of_empty_rows")}: </b></span><span>{responseData && responseData.numberOfEmptyRows}</span></p>
                                <p><span><b>{this.props.t("number_of_invalid_rows")}: </b></span><span>{responseData && responseData.numberOfInvalidRows}</span></p>
                                <p><span><b>{this.props.t("number_of_partial_rows")}: </b></span><span>{responseData && responseData.numberOfPartialRows}</span></p>
                                <p><span><b>{this.props.t("invalid_rows")}: </b></span><span>{responseData.invalidRows && responseData.invalidRows.join(", ")}</span></p>
                            </CardContent>
                        </Card>
                    </Grid>}
                </Grid>
            </Grid>
        </Grid >
    }
}

export default withSnackbar(withTranslation()(ImportChartOfAccount))